<template>
  <div>
    <base-header class="bg-vg-gradient pb-6 pb-8 pt-5 pt-md-8"></base-header>
    <div class="container-fluid mt--9">
      <el-form :model="model" :rules="rules">
        <div class="row" v-loading="loading">
          <div class="col-xl-12">
            <card shadow type="secondary">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-8">
                    <h3 class="mb-0">Şifre İşlemleri</h3>
                  </div>
                </div>
              </div>
              <template>
                <h6 class="heading-small text-muted mb-4">Şifre Değiştirme Formu</h6>
                <div class="pl-lg-4">
                  <div class="row">
                    <div class="col-lg-12">
                      <label class="form-control-label">Mevcut Şifreniz</label>
                      <el-form-item prop="password" class="form-control-alternative">
                        <el-input v-model="model.current_password" type="password"
                                  placeholder="Mevcut Şifreniz"></el-input>
                      </el-form-item>

                    </div>
                  </div>
                  <div class="row">
                    <div class="col-lg-6">
                      <label class="form-control-label">Yeni Şifreniz</label>
                      <password
                          placeholder="Yeni Şifreniz"
                          v-model="model.new_password"
                          :show-password="false"
                          :badge="false"
                          :toggle="true"
                      />
                    </div>
                    <div class="col-lg-6">
                      <label class="form-control-label">Yeni Şifreniz (tekrar)</label>
                      <password
                          placeholder="Yeni Şifreniz"
                          v-model="model.new_password_verify"
                          :show-password="false"
                          :badge="false"
                          :toggle="true"
                      />
                    </div>
                    <div class="col-lg-12">
                      <div class="alert alert-danger" v-if="result !== null">{{ result }}</div>
                      <div
                          class="alert alert-danger"
                          v-for="(error , index) in validationErrors.password"
                          :key="index"
                      >* {{ error }}
                      </div>
                    </div>
                    <div class="col-12 text-right">
                      <base-button
                          type="button"
                          id="submit"
                          native-type="submit"
                          class="btn btn-sm btn-primary"
                          @click="validateForm('model',false)"
                      >Şifre Değiştir
                      </base-button>
                    </div>
                  </div>
                </div>
              </template>
            </card>
          </div>
        </div>
      </el-form>
    </div>
  </div>
</template>
<script>
import Password from "vue-password-strength-meter";
import * as axios from "axios";

export default {
  components: {Password},
  name: 'change-password',
  data() {
    return {
      result: null,
      loading: false,
      validationErrors: {
        password: [],
      },
      model: {
        current_password: '',
        new_password: '',
        new_password_verify: '',
      },
      rules: {
        current_password: [
          {required: true, message: 'Lütfen mevcut şifrenizi giriniz', trigger: 'blur'},
        ]
      },
    }
  },
  methods: {
    validateForm: function () {
      this.validationErrors = {
        password: []
      };
      if (!this.model.current_password) {
        this.validationErrors.password.push("Şifre gereklidir");
      }
      if (this.model.current_password && !this.model.new_password_verify
      ) {
        this.validationErrors.password.push("Şifre tekrar gereklidir");
      }
      if (this.model.new_password !== this.model.new_password_verify) {
        this.validationErrors.password.push("Şifreler uyuşmuyor");
      }
      if (this.validationErrors.password.length === 0) {
        this.loading = true;
        this.changePassword();

      }
    },
    changePassword() {
      // eslint-disable-next-line no-unused-vars
      axios.post('/user/change-password', this.model).then(response => {
        this.result = null;
        this.$notify.success({
          title: 'Başarılı',
          message: 'Şifreniz başarıyla değiştirildi.',
        });
        this.loading = false;
        document.getElementById("submit").hidden = true;
      })
          .catch((error) => {
            this.result = error.response.data.messages[0];
            this.loading = false;
          });
    }
  }
}
</script>
<style>
.Password {
  max-width: unset !important;
}
.alert {
  padding: 0.5rem 1rem;
}
</style>
